import React from 'react';
import TabbedPage from '../../../../Elements/TabbedPage';
import PaymentExportDetailsInfo from './PaymentExportDetailsInfoTab';
import PaymentExportDetailsPaymentExportsTab from './PaymentExportDetailsPaymentExportsTab';
import GeneralEntryLogFigma from '../../../../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../../../../Elements/CommentsEntryLogDescription';
import AttachmentsComponent from '../../../../Elements/AttachmentsComponent';

export default class PaymentExportDetails extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  exportId = this.urlParams.get('id');

  componentDidMount() {}

  tabs = [
    { label: 'Information', id: 'info', icon: 'fa-solid fa-info', component: <PaymentExportDetailsInfo /> },
    {
      label: 'Evaluator Payments',
      id: 'payments',
      icon: 'fa-solid fa-money-bill-wave',
      component: <PaymentExportDetailsPaymentExportsTab exportId={this.exportId} />,
    },
    {
      label: 'Comments',
      id: 'payments',
      icon: 'fa-solid fa-money-bill-wave',
      component: (
        <GeneralEntryLogFigma
          description={CommentsEntryLogDescription}
          context={{ entityTypeId: 38, entityId: this.exportId }}
        />
      ),
    },
    {
      label: 'Attachments',
      id: 'payments',
      icon: 'fa-solid fa-money-bill-wave',
      component: (
        <AttachmentsComponent
          entityTypeId={38}
          entityId={this.exportId}
          enableAddNew={true}
        />
      ),
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <TabbedPage tabs={this.tabs} />
      </div>
    );
  }
}
